import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 17 16",
  class: "th-icon"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      fill: "currentColor",
      d: "M9.491 5.333h.667a.667.667 0 1 0 0-1.333H9.49a.667.667 0 0 0 0 1.333m0 2.667h.667a.667.667 0 1 0 0-1.333H9.49a.667.667 0 0 0 0 1.333M6.158 5.333h.666a.667.667 0 0 0 0-1.333h-.666a.667.667 0 0 0 0 1.333m0 2.667h.666a.667.667 0 0 0 0-1.333h-.666a.667.667 0 1 0 0 1.333m8 5.333h-.667V2a.667.667 0 0 0-.667-.667H3.491A.667.667 0 0 0 2.824 2v11.333h-.666a.667.667 0 1 0 0 1.334h12a.667.667 0 0 0 0-1.334m-5.334 0H7.491v-2.666h1.333zm3.334 0h-2V10a.667.667 0 0 0-.667-.667H6.824a.667.667 0 0 0-.666.667v3.333h-2V2.667h8z"
    }, null, -1)
  ]))]))
}
import { markRaw } from 'vue'
export default markRaw({ render: render })